import React, { useState } from 'react';
import { SketchPicker } from 'react-color';
import OutsideClickHandler from 'react-outside-click-handler';
import { Box, Button, Text } from '../../ui';

type ColorPickerProps = {
  selectedColor: string;
  presets: string[];
  onSelect: (arg0: string) => void;
  label: string;
};

const ColorPicker = ({
  selectedColor,
  presets,
  onSelect,
  label,
}: ColorPickerProps) => {
  const [visible, setVisible] = useState(false);
  const [color, setColor] = useState(selectedColor);

  // Class name used for toggle button and OutsideClickHandler check
  const toggleClass = `toggle-button-${label.replace(' ', '')}`;

  return (
    <>
      <Button
        className={toggleClass}
        onClick={() => {
          setVisible(!visible);
        }}
        data-testid="color-picker"
        sx={{
          variant: 'buttons.link',
          pl: 0,
          py: 2,
        }}
      >
        <ColorPreview color={selectedColor} />
        <Text variant="baseDark" pl={2}>
          {label}
        </Text>
      </Button>
      {visible && (
        <Box sx={{ position: 'absolute', top: 0, left: 32, zIndex: 'modal' }}>
          <OutsideClickHandler
            onOutsideClick={(e: any) => {
              if (!e.target?.parentElement.classList.contains(toggleClass)) {
                setVisible(false);
              }
            }}
          >
            <SketchPicker
              disableAlpha={true}
              color={color}
              presetColors={presets}
              onChange={(color) => setColor(color.hex)}
              onChangeComplete={(color) => onSelect(color.hex)}
            />
          </OutsideClickHandler>
        </Box>
      )}
    </>
  );
};

type ColorPreviewProps = {
  color: string;
  onClick?: () => void;
  sx?: any;
};

const ColorPreview = ({ color, onClick, sx }: ColorPreviewProps) => (
  <Box
    sx={{
      width: 24,
      height: 24,
      borderRadius: 999,
      backgroundColor: color,
      cursor: 'pointer',
      border: '1px solid rgba(255, 255, 255, 0.24)',
      ...sx,
    }}
  />
);

export default ColorPicker;
